import { Box, Image } from '@chakra-ui/react';

const EmptyIcon = ({ src }) => {
  
  // consoleLog(src, 'image of the icons ');
  return (
    <Box>
      <Image float={'left'} display="table" src={src} alt="icon" title='icon'/>
    </Box>
  );
};
const FilledIcon = ({ src }) => {
  return (
    <Box>
      <Image float={'left'} src={src} display="table" alt="icon" title='icon' />
    </Box>
  );
};
export { EmptyIcon, FilledIcon };

